export default {
  LIST_FETCHED: 'ACTIVITIES_FETCHED',
  LIST_LOAD: 'ACTIVITY_LOAD',
  ITEM_DETAIL: 'ACTIVITY_DETAIL',
  BUTTON_LOAD: 'ACTIVITY_BUTTON_LOAD',
  SUBSCRIBED: 'ACTIVITY_SUBSCRIBED',
};
